// @ts-check

import React, { Component } from 'react';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';
import { Row, Widget } from 'shared/containers/portal_layout';
import OrganizationSpecialtyQuestionnaireTemplateEditor from 'shared/components/OrganizationSpecialtyQuestionnaireTemplateEditor';
import ToggleSwitch from 'shared/components/ToggleSwitch';

class QuestionnaireTemplates extends Component {
  constructor() {
    super();
    this.state = {
      specialties: null,
      activeSpecialtyId: null,
    };
  }

  componentDidMount() {
    this.refresh();
  }

  chooseSpecialty = specialtyId => {
    this.setState({ activeSpecialtyId: specialtyId });
  };

  activeSpecialty = () => {
    return this.state.specialties.find(specialty => specialty.id === this.state.activeSpecialtyId);
  };

  toggleCustom = (specialtyId, event) => {
    api
      .put(
        `/agent_portal/api/organizations/${this.props.params.entityId}/specialties/${specialtyId}/organization_specialty_configuration`,
        {
          configuration: {
            use_custom_questionnaire_template: event.target.checked,
          },
        }
      )
      .then(() => {
        this.refresh();
      });
  };

  refresh = () => {
    api
      .get(
        `/agent_portal/api/organizations/${this.props.params.entityId}/organization_specialty_configurations`
      )
      .then(response => {
        this.setState({ specialties: response.data.specialties });
      });
  };

  render() {
    if (!this.state.specialties) return <LoadingContent />;
    return (
      <div>
        <Row>
          <Widget title="Specialty Template Configuration" span={12}>
            <table className="table table-bordered table-stripe">
              <thead>
                <tr>
                  <th>Specialty</th>
                  <th>Use Custom Questionnaire</th>
                  <th>Edit Custom Questionnaire</th>
                </tr>
              </thead>
              <tbody>
                {this.state.specialties.map(specialty => (
                  <tr key={specialty.id}>
                    <td>{specialty.name}</td>
                    <td>
                      <ToggleSwitch
                        id={`useCustomQuestionnaire-${specialty.id}`}
                        checked={specialty.useCustomQuestionnaireTemplate}
                        onChange={event => this.toggleCustom(specialty.id, event)}
                      />
                    </td>
                    <td>
                      {specialty.useCustomQuestionnaireTemplate && (
                        <button
                          onClick={() => this.chooseSpecialty(specialty.id)}
                          className="btn btn-primary btn-mini"
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Widget>
        </Row>
        {this.state.activeSpecialtyId && (
          <Row>
            <Widget title={`Edit ${this.activeSpecialty().name} Questionnaire`} span={12}>
              <OrganizationSpecialtyQuestionnaireTemplateEditor
                key={this.state.activeSpecialtyId}
                specialtyId={this.state.activeSpecialtyId}
                organizationId={this.props.params.entityId}
                apiPrefix="/agent_portal/api"
              />
            </Widget>
          </Row>
        )}
      </div>
    );
  }
}

export default QuestionnaireTemplates;
